import dayjs from "dayjs"
import { DateFormat } from 'us.collection.case/constants'

export const initialValue = {
    category: "",
    date: dayjs().add(7, 'days').format(DateFormat),
    assign: "all",
    note: "",
    reasonSearch: "",
    reasonName: "",
    reason: '',
}